// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"844497ba","239":"cb056a29","455":"24808350"}[chunkId] + ".chunk.js";
};